
import CoreFormElementInputBase from './BaseInput';
import { CoreFormElementProps } from '../../interfaces/';
import { FORM_ELEMENT_PROPS, INPUT_TYPE_HIDDEN } from '../../constants/';
import { HashMapMergeProps } from '../../../../../utils/';

/**
 * Hidden Input Element
 * @export
 * @class CoreFormElementRadio
 * @extends {CoreFormElementInputBase}
 */
export default class CoreFormElementRadio extends CoreFormElementInputBase {
  /**
   * Default Props
   * @static
   * @type {Omit<CoreFormElementProps, 'name'>}
   * @memberof CoreFormElementFile
   */
  public static defaultProps: Omit<CoreFormElementProps, 'name'> = HashMapMergeProps(FORM_ELEMENT_PROPS, {
    type: INPUT_TYPE_HIDDEN
  });
}
